import { render } from "./FlashCourseware.vue?vue&type=template&id=409d9bd6&scoped=true"
import script from "./FlashCourseware.vue?vue&type=script&lang=js"
export * from "./FlashCourseware.vue?vue&type=script&lang=js"

import "./FlashCourseware.vue?vue&type=style&index=0&id=409d9bd6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-409d9bd6"

export default script